import { render } from "./GlobalTransactionXmoneyView.vue?vue&type=template&id=d584ff50"
import script from "./GlobalTransactionXmoneyView.vue?vue&type=script&lang=js"
export * from "./GlobalTransactionXmoneyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__